var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-form',{attrs:{"form":_vm.form,"label-col":{ span: 9 },"wrapper-col":{ span: 7 }},on:{"submit":_vm.submit}},[_c('h3',{staticStyle:{"text-align":"center","margin-top":"48px"}},[_vm._v("Urządzenie")]),_c('a-form-item',{attrs:{"label":"Adres MAC"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'macAddress',
          {
            rules: [
              {
                required: true,
                message: 'Adres MAC jest wymagany!',
              }
            ],
          },
        ]),expression:"[\n          'macAddress',\n          {\n            rules: [\n              {\n                required: true,\n                message: 'Adres MAC jest wymagany!',\n              }\n            ],\n          },\n        ]"}],attrs:{"placeholder":"AA:BB:CC:DD:EE:FF","maxLength":17}})],1),_c('a-form-item',{attrs:{"label":"Adres IP"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
          'ipAddress',
          {
            rules: [
              {
                required: true,
                message: 'Adres IP jest wymagany!',
              }
            ],
          },
        ]),expression:"[\n          'ipAddress',\n          {\n            rules: [\n              {\n                required: true,\n                message: 'Adres IP jest wymagany!',\n              }\n            ],\n          },\n        ]"}],attrs:{"maxLength":20,"placeholder":"np. 10.20.0.2"}})],1)],1),_c('a-row',{staticStyle:{"text-align":"center"}},[_c('a-button',{staticStyle:{"margin-right":"24px"},attrs:{"type":"default"},on:{"click":_vm.back}},[_c('a-icon',{attrs:{"type":"left"}}),_vm._v(" Wróć ")],1),_c('a-button',{attrs:{"disabled":!_vm.isVerificationCompleted,"type":"primary"},on:{"click":_vm.submit}},[_vm._v(" Dalej "),_c('a-icon',{attrs:{"type":"right"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }